import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

import { VISIT_STATUS_TO_COLOR_MAP } from "~/config/statusColors";

type Props = PropsWithChildren & {
    plannerStatusBucket: string;
};

export default function IconArea({ plannerStatusBucket, children }: Props) {
    const iconColor = VISIT_STATUS_TO_COLOR_MAP[plannerStatusBucket] ?? "#000";

    return (
        <Box
            sx={{
                width: 46,
                height: 46,
                boxSizing: "border-box",
                borderRadius: "100%",
                backgroundColor: "transparent",
                border: `8px solid ${iconColor}`,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {children}
        </Box>
    );
}
